var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudFillIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 31.95,
    viewBox: "0 0 44 31.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cloud_upload_FILL1_wght400_GRAD0_opsz48",
    d: "M22.5,40H12.55a10.176,10.176,0,0,1-7.475-3.075A10.176,10.176,0,0,1,2,29.45,10.276,10.276,0,0,1,4.5,22.6a10.1,10.1,0,0,1,6.35-3.55,13.554,13.554,0,0,1,4.7-7.925A12.985,12.985,0,0,1,24.1,8.05a12.5,12.5,0,0,1,9.45,4.075A13.732,13.732,0,0,1,37.4,21.9v1.2a8.088,8.088,0,0,1,6.1,2.325A8.173,8.173,0,0,1,46,31.55,8.537,8.537,0,0,1,37.55,40H25.5V24.1l4.15,4.15L31.8,26.1,24,18.3l-7.8,7.8,2.15,2.15L22.5,24.1Z",
    transform: "translate(-2 -8.05)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFillIcon);
export default __webpack_public_path__ + "static/media/CloudFillIcon.ed3ad42a28d183ec20cc508d104b5286.svg";
export { ForwardRef as ReactComponent };